import React from 'react';

import './Contact.css';

function Contact() {
  return (
    <section className="contact">
      <div className="contact__inner">
        <div className="contact__content">

          <h2 className="contact__title">Get in touch</h2>

          <p className="contact__description">
            We will be happy to assist with availability, rates and special requests.
          </p>

          <div className="contact__details">
            <div className="contact__item">
              <span className="contact__item-label">Address</span>
              <p className="contact__item-text">
                Villa Mandragora, Orahovac, Kotor, Montenegro
              </p>
            </div>

            <div className="contact__item">
              <span className="contact__item-label">Phone</span>

              <a href="tel:+38267429342" className="contact__link">
                +382 67 429 342
              </a>
            </div>

            <div className="contact__item">
              <span className="contact__item-label">WhatsApp</span>

              <a
                href="https://wa.me/38267429342"
                className="contact__button"
                target="_blank"
                rel="noreferrer"
              >
                Message on WhatsApp
              </a>
            </div>

            <div className="contact__item">
              <span className="contact__item-label">Email</span>

              <a
                href="mailto:info@villamandragora.me"
                className="contact__link"
              >
                info@villamandragora.me
              </a>
            </div>
          </div>
        </div>

        <div className="contact__map">
          <iframe
            title="Villa Mandragora location map"
            src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d612.0459344762937!2d18.765383895367123!3d42.48805177931611!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e1!3m2!1sen!2sse!4v1780163087218!5m2!1sen!2sse"
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>

          <a
            href="https://www.google.com/maps/search/?api=1&query=42.48805177931611,18.765383895367123"
            className="contact__directions"
            target="_blank"
            rel="noreferrer"
          >
            Get directions
          </a>
        </div>
      </div>
    </section>
  );
}

export default Contact;
